/* import __COLOCATED_TEMPLATE__ from './item.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import { readOnly, empty } from '@ember/object/computed';
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
const DETAILED_DESCRIPTION_ELEMENT = '.event-timeline__item__detailed-description';

/**
## Timeline Event

Used as a contextual component in the `event-timeline` component.

If passed in a block to the component, that content will take precedence over any passed in content
Example:
<Timeline.item @showGraphicBottomLine={{true}}>
  <p>This content will render in place of the descriptions, callToAction, and viewMore elements from passed in params</p>
</Timeline.item>

@param {String} event.description
@param {String} event.detailedDescription
@param {DateTime} event.occurredAt
@param {Boolean} isFirstItem - whether to use special spacing for the first item
@param {Boolean} showGraphicBottomLine - whether to render line below the timeline graphic dot
@param {Boolean} shouldTruncateDescriptions - if true long detailedDescriptions will be cut off with a viewDetailedDescription link
@param {Boolean} showGraphicTopLine - whether to render the line above the timeline graphic dot
@param {Action} viewMoreLink.action - action for if shouldTruncateDescriptions is true
@param {String} viewMoreLink.text - text for if shouldTruncateDescriptions is true
@param {String} callToAction.text - text for the call to action if there is one
@param {String} callToAction.href - URL if call to action should be a link (cannot be used with `callToAction.action`)
@param {Action} callToAction.action - action if there is a call to action (cannot be used with `callToAction.href`)
*/
let Item = (_dec = classNames('event-timeline__item'), _dec2 = readOnly('event.description'), _dec3 = readOnly('event.occurredAt'), _dec4 = readOnly('event.detailedDescription'), _dec5 = empty('detailedDescription'), _dec(_class = (_class2 = class Item extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "event", null);
    _defineProperty(this, "isFirstItem", false);
    _defineProperty(this, "shouldTruncateDescriptions", false);
    _defineProperty(this, "showGraphicTopLine", true);
    _defineProperty(this, "viewMoreLink", null);
    _defineProperty(this, "callToAction", null);
    _initializerDefineProperty(this, "description", _descriptor, this);
    _initializerDefineProperty(this, "occurredAt", _descriptor2, this);
    _initializerDefineProperty(this, "detailedDescription", _descriptor3, this);
    _initializerDefineProperty(this, "isDetailedDescriptionEmpty", _descriptor4, this);
  }
  get didDetailedDescriptionOverflow() {
    const element = document.getElementsByClassName(DETAILED_DESCRIPTION_ELEMENT)[0];
    if (element) {
      return element.scrollWidth > element.clientWidth;
    }
    return true;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "occurredAt", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "detailedDescription", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "isDetailedDescriptionEmpty", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "didDetailedDescriptionOverflow", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "didDetailedDescriptionOverflow"), _class2.prototype), _class2)) || _class);
export { Item as default };